<template>
    <div :class="classTheme+' theme'">
        <div class="body-bg">
            <nsw-header ref="nswHeader" v-show="showHeader"></nsw-header>
            <router-view></router-view>
            <my-download ref="myDownload"></my-download>
            <login-popup ref="loginPopup"></login-popup>
            <hkep-loading
                    ref="hkepLoading"
                    :color="'#007ac6'"
                    size="100"
            >
            </hkep-loading>
            <video-player :options="videoOptions" ref="videoComponent"></video-player>
            <pdf-viewer ref="pdfViewer"></pdf-viewer>
            <audio-player ref="html5player"></audio-player>
            <hkep-msg-pop
                ref="hkepMsgPop"
                :img="origin_url+'/img/alert_icon.jpg'"
            ></hkep-msg-pop>
            <hkep-popup></hkep-popup>
        </div>

    </div>
</template>

<script>

    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';
    import api from '@js/api';
    import LaravelEcho from "laravel-echo";
    import HkepPopup from "./HkepPopup";
    import * as i18n from '@js/i18n';

    export default {
        name: 'app',
        components: {HkepPopup},
        mixins:[common,storeMapper],
        mounted() {
            this.listenEvents();
            if (website_lang !== null && website_lang !== "" && website_lang !== undefined) {
                i18n.changeLocale(website_lang);
            }

            window.Echo = new LaravelEcho({
                broadcaster: 'socket.io',
                host: window.location.hostname,
                authHost: window.location.protocol+"//"+window.location.hostname,
                key: "8911a70fd3ab6f7350b937d5a1745683",
                headers: {
                    'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
                },
                auth: {
                    headers: {
                        Authorization: `Bearer 8911a70fd3ab6f7350b937d5a1745683`
                    }
                },
                cluster: 'us3',
                encrypted: true,
                enabledTransports: ['ws', 'wss'],
                transports: ['websocket']
            });
        },
        data() {
            return {
                videoOptions: {},
                showHeader: true,
                origin_url: window.location.origin
            }
        },
        watch: {
            '$route' (to, from) {
                this.$refs.videoComponent.destroy();
                this.$refs.myDownload.close();
                this.$refs.loginPopup.close();
                this.$refs.pdfViewer.destroy();
                this.$refs.html5player.destroy();
                this.checkLoginStatus();
                EventBus.$emit('unselect_select_all_btn');

            }
        },
        methods: {
            listenEvents() {
                EventBus.$on("showGlobalLoading", ()=>{
                    this.$refs.hkepLoading.show();
                });

                EventBus.$on("hideGlobalLoading", ()=>{
                    this.$refs.hkepLoading.hide();
                });

                EventBus.$on("showMyDownload", (displayPosition)=>{
                    EventBus.$emit("closeFilter");
                    this.$refs.myDownload.show(displayPosition);
                });

                EventBus.$on("closeMyDownload", ()=>{
                    this.$refs.myDownload.close();
                });

                EventBus.$on("showLogin", ()=>{
                    this.$refs.loginPopup.show();
                });

                EventBus.$on("hideLogin", ()=>{
                    this.$refs.loginPopup.close();
                });

                EventBus.$on("checkLogin", ()=>{
                    this.$refs.nswHeader.isLoggedIn();
                });

                EventBus.$on("showVideo", (url)=>{
                    this.videoOptions = {
                        autoplay: true,
                        controls: true,
                        sources: [
                            {
                                src: url,
                                type: "video/mp4"
                            }
                        ]
                    };
                    this.$refs.videoComponent.setOptions(this.videoOptions, url);

                });

                EventBus.$on("readPDF", (json) => {
                    this.$refs.pdfViewer.viewPdf(json);
                });

                EventBus.$on("hideHeader", () => {
                    this.showHeader = false;
                });

                EventBus.$on("showHtml5Player", (data) => {
                    this.$refs.html5player.show(data.type, data.url);
                });

                EventBus.$on("hideHeaderRightPanel", () => {
                    this.$refs.nswHeader.hideRightPanel();
                });

                EventBus.$on("showHkepMsgPop", (content) => {
                    this.$refs.hkepMsgPop.setContent(content);
                    this.$refs.hkepMsgPop.show();

                });


            },
            checkLoginStatus()
            {
                if (
                    this.$route.name !== "Terms"
                    && this.$route.name !== "Disclaimer"
                    && this.$route.name !== "ContactUs"
                    && this.$route.name !== "ireaderResourcePage"

                ) {
                    api.checkLoginStatus(this.$route.path).then( resp => {

                    }).catch(error=>{
                        location.reload();
                    });
                }

            }
        },
        computed: {
            classTheme() {
                return this.storeMainSite.theme;
            }
        }
    }
</script>

<style>

    #video {
        max-height: 100%;
        text-align: center;
        display: block;
        width: 100%;
    }
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/App.vue